import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconToast"><Path d="M12 3C9.34018 3 6.89523 3.6103 5.08906 4.63542C3.30507 5.64796 2 7.16238 2 9C2 10.4383 2.80469 11.683 4 12.6342V21H20V12.6342C21.1953 11.683 22 10.4383 22 9C22 7.16238 20.6949 5.64796 18.9109 4.63542C17.1048 3.6103 14.6598 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconToast;
